import { AllSanitySchemaTypes } from '@sanity-types-queries'

export type SanityDocType = Extract<AllSanitySchemaTypes, { _type: string }>['_type']

export const SANITY_DOC_TYPE = new Proxy({} as { [k in SanityDocType]: k }, {
  get: (_, property: SanityDocType) => property
})
